import * as L from 'leaflet';
import { environment } from '../../../environment';

/** The same street basemap for the workspace map and read-only location previews. */
export function createBaseTileLayer(): L.TileLayer {
  return L.tileLayer(
    `https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=${environment.mapboxToken}`,
    {
      id: 'mapbox/streets-v11', tileSize: 512, zoomOffset: -1,
      detectRetina: true, maxZoom: 22,
      attribution: '© <a href="https://www.mapbox.com/about/maps/" target="_blank" rel="noopener">Mapbox</a> © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
    },
  );
}
